import { pkMinMax, type PkLike } from './pkCompare';

/**
 * La ventana de PK con la que se pide el trazado para DIBUJAR el mapa de una
 * Actuación o un Accidente.
 *
 * Existe aparte del componente para poder probarla: se escribió a la vez que el
 * arreglo del kilómetro largo y sin cobertura de test, que es justo lo que no
 * debe volver a pasar.
 *
 * ── Qué hace ───────────────────────────────────────────────────────────────
 *
 * Cuando los dos PK están en el MISMO kilómetro y casi pegados, el trecho es
 * puntual y el servidor no devolvería vértices con los que dibujar nada. Ahí se
 * ensancha ±300 m **solo para el dibujo**; los PK del formulario no se tocan.
 *
 * 🔴 El ensanchado va sobre los METROS DE CADA EXTREMO, sin pasar por
 * `km * 1000 + meter`. Antes se sumaba al total y se deshacía con `floor` y `%`,
 * y eso convierte un `84+1800` —legítimo, el kilómetro 84 de la C-17 mide
 * 1.890 m— en `85+800`: la consulta pedía OTRO trozo de carretera y el mapa
 * dibujaba donde no era.
 *
 * En kilómetros distintos no se ensancha: ya hay ventana de sobra.
 */
export const PUNTUAL_METERS = 200;
export const MARGEN_METERS = 300;

export const drawingWindow = (
  a: PkLike,
  b: PkLike
): { lo: PkLike; hi: PkLike } => {
  const [lo, hi] = pkMinMax(a, b);
  const esPuntual =
    lo.km === hi.km && Math.abs(hi.meter - lo.meter) < PUNTUAL_METERS;
  if (!esPuntual) return { lo, hi };
  return {
    lo: { km: lo.km, meter: Math.max(0, lo.meter - MARGEN_METERS) },
    hi: { km: hi.km, meter: hi.meter + MARGEN_METERS },
  };
};
